export enum DatePickerFormat {
  DATE = 'DD.MM.YYYY',
  DATE_TIME = 'DD.MM.YYYY HH:mm',
  MONTH = 'MM.YYYY',
  MONTH_LONG = 'MMMM YYYY',
}